import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import Game from '../components/Game';
import { useApp } from '../hooks/useApp';
import socketService from '../services/socketService';
import { useState } from 'react';

const GamePage = () => {
  const [isReconnection, setIsReconnection] = useState(false);
  const {
    socket,
    board,
    draw,
    username,
    leaveRoom,
  } = useApp();


  // React Query hooks

  const handleHuntAgain = () => {
    leaveRoom();
  };


  // Add useEffect to handle reconnection events
useEffect(() => {
  const handleRejoinSuccess = ({ roomId, username }) => {
    // Show success notification
    // You can use your existing notification system
  };

  const handleGameStart = ({ roomId, rejoin }) => {
    if (rejoin) {
      // Show rejoin success message
      // Update UI to show reconnection was successful
      
      console.log('Reconnected successfully!', roomId,rejoin);
      toast.success('Reconnected successfully!');
    }
  };

  socketService.addEventListener('rejoinSuccess', handleRejoinSuccess);
  socketService.addEventListener('gameStart', handleGameStart);

  return () => {
    socketService.removeEventListener('rejoinSuccess', handleRejoinSuccess);
    socketService.removeEventListener('gameStart', handleGameStart);
  };
}, []);



  return (
    <Game
      socket={socket}
      board={board}
      draw={draw}
      username={username}
      onHuntAgain={handleHuntAgain}
    />
  );
};

export default GamePage;
